module.exports = __webpack_public_path__ + "img/banner-1.3b14c432.jpg";